import type React from 'react';

import { TrackingContext } from '@change-corgi/core-react/tracking';

import { useHomepagePageData } from '#src/app/pages/homepage/pageContext';
import {
	HeroTitle,
	PetitionMarquee,
	Tagline,
	TopImpactStoriesDesktop,
	TopImpactStoriesMobile,
	TopImpactStoriesMobileProvider,
} from '#src/app/pages/homepage/shared/components';

import { SocialPostUrlForm } from './components/SocialPostUrlForm';
import { useInputSourcesArm } from './hooks/useInputSourcesArm';

export const HeroSocialPostToDraft: React.FC<EmptyProps> = () => {
	const {
		data: { topImpactStories, shouldShowPetitionMarquee },
	} = useHomepagePageData();
	const {
		data: { multiSource, variation },
	} = useInputSourcesArm();

	return (
		<section data-testid="homepage-social-post-hero-section" className="text-typography-strong relative">
			<div className="relative z-10 pt-6 md:pt-11 lg:pt-15">
				<div className="container">
					<HeroTitle className="m-0 text-center" />
					{/* tags every event in the link flow with the arm, including the shared captcha events */}
					<TrackingContext properties={{ multi_source: multiSource, input_sources_variation: variation }}>
						<SocialPostUrlForm />
					</TrackingContext>
					<Tagline />
				</div>

				{/* Show petition marquee in hero or fallback to top impact stories */}
				{shouldShowPetitionMarquee ? (
					<div className="m-auto max-w-480">
						<PetitionMarquee className="pt-5 md:pt-8" simple />
					</div>
				) : (
					<>
						{topImpactStories.length > 0 && (
							<div className="container">
								<TopImpactStoriesDesktop layout="row" />
							</div>
						)}
						{topImpactStories.length > 0 && (
							<TopImpactStoriesMobileProvider>
								<TopImpactStoriesMobile />
							</TopImpactStoriesMobileProvider>
						)}
					</>
				)}
			</div>
		</section>
	);
};
